<template lang="pug">
.account-teams
  .row
    .col-12
      p(style='max-width: 750px; margin-top: 10px')
        | {{ $t('pages.teams.description') }}
      ul#my-tab.nav.nav-tabs(role='tablist')
        li.nav-item.active(role='presentation')
          .nav-link.active {{ pageTitleText }}

  .row.mt-4
    .col-12
      .row
        .col-12.col-md-6(v-if='hasTeams')
          .form-group.d-flex.flex-md-row
            .form-control-icon--end-line(style='width: 400px')
              input#name.form-control.rounded-3(
                :placeholder='$t("pages.teams.searchPlaceholder")'
                autocomplete='off'
                v-model='filters.search'
              )
              icon(name='magnifying-glass')
        .col-12.col-md-6.text-end(v-if='hasTeams')
          .btn-create-team
            button.btn.btn-primary.btn--create-team(
              @click='createTeam'
              v-if='isOwner'
            )
              | {{ $t('pages.teams.createTeam') }}

  .row(v-if='!hasTeams')
    .col-12.mt-5
      .text-center.mt-5
        img.img-fluid.img(
          src='/img/ilustrations/mailbox-no-contacts.svg'
          style='max-height: 260px'
        )
        p.mt-4
          | {{ $t('message.no_teams') }}
        button.btn.btn-primary.mt-3(@click='createTeam' v-if='isOwner')
          | {{ $t('pages.teams.createTeam') }}

  .row(v-else-if='filteredTeams.length === 0 && isSearchingTeams')
    .col-12.mt-5
      .text-center.mt-5
        img.img-fluid.img(
          src='/img/ilustrations/no-contacts-found.svg'
          style='max-height: 260px'
        )
        p.mt-4 {{ $t('message.no_results_found') }}

  .row(v-else-if='filteredTeams.length > 0')
    .col-12
      teams-card-table(
        :data='filteredTeams'
        @item-deleted='listTeams'
        @item-edited='listTeams'
      )
  create-team-modal(@refresh='listTeams' ref='createTeamModal')
  new-envelope-mobile-modal
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import TeamsService from '@/modules/account/services/http/TeamsService';
import CreateTeamModal from '@/modules/account/components/organisms/modals/CreateTeamModal.vue';
import NewEnvelopeMobileModal from '@/modules/business/components/organisms/modals/NewEnvelopeMobileModal.vue';
import TeamsCardTable from '@/modules/account/components/organisms/card-table/TeamsCardTable.vue';

export default {
  name: 'TeamsPage',
  components: {
    Icon,
    NewEnvelopeMobileModal,
    CreateTeamModal,
    TeamsCardTable,
  },
  data() {
    return {
      teams: {
        data: [],
        links: {},
        meta: {},
      },
      filters: {
        search: '',
      },
      selectedTeam: {},
    };
  },
  created() {
    if (!this.$store.state.organizations.selected?.metadata?.['team.enabled']) {
      this.$router.replace({ name: 'account.profile' });
      return;
    }
    this.updatePageStrings();
    this.listTeams();
  },
  computed: {
    pageTitleText() {
      return this.isOwner
        ? this.$t('pages.teams.pageTitleAdmin')
        : this.$t('pages.teams.pageTitleUser');
    },
    tableHead() {
      return [
        { label: this.$t('teamsCardTable.name') },
        { label: this.$t('teamsCardTable.users') },
        { label: ' ' },
      ];
    },
    hasTeams() {
      return this.teams.data.length > 0;
    },
    isSearchingTeams() {
      return this.filters.search !== '';
    },
    filteredTeams() {
      const search = this.filters.search.toLowerCase().trim();
      if (!search) return this.teams.data;
      return this.teams.data.filter(
        (team) => team.name && team.name.toLowerCase().includes(search)
      );
    },
    isOwner() {
      return this.$store.state.organizations.selected?.is_owner;
    },
  },
  methods: {
    updatePageStrings() {
      this.$store.dispatch('page/setTitle', this.pageTitleText);
      this.$store.dispatch('page/setHead', this.pageTitleText);
      this.$store.dispatch('page/setClass', 'account teams');
    },
    async listTeams(page = 1) {
      this.$loading(true);
      const params = new URLSearchParams({ page });
      const result = await TeamsService.list(params);
      this.teams = result.data;
      this.$loading(false);
    },
    createTeam() {
      this.$refs.createTeamModal.$refs.modal.open();
    },
  },
};
</script>
<style lang="stylus">
.account-teams
  .action
    min-width: 100px
    button
      .icon
        font-size: 1.1rem
        margin-right: 5px
    button:nth-child(1)
      .icon
        color: #013D52
  .team-name
    position: relative
    .team-icon
      position: absolute
      top: 30%
  .btn--create-team
    margin-bottom: 2rem
    width: 100%
@media (min-width: 992px)
  .account-teams
    .btn--create-team
      max-width: 180px
@media screen and (max-width: 768px)
  .account-teams
    .table
      tbody
        tr
          position: relative
          display: flex
          flex-direction: row
          flex-wrap: wrap
          padding-left: 0
          td
            padding-left: 13px
            flex: 0 0 80%
    .subject
      order: 1
      .paper-icon
        display: none
    .data
      order: 3
    .action
      order: 2
      .dropdown-toggle
        position: absolute
        top: 50%
        margin-top: -0.65rem
        &:nth-child(1)
          right: 55px
</style>
